import type { MediaItem } from "@/types/media";

export const mediaList: MediaItem[] = [
  {
    id: "m1",
    title: "星际迷航者",
    type: "movie",
    year: 2024,
    region: "美国",
    genres: ["科幻", "冒险"],
    rating: 8.7,
    heat: 9850,
    duration: "142分钟",
    director: "陈远航",
    cast: ["林浩然", "苏梦琪", "Daniel Reyes"],
    synopsis:
      "一支孤舰穿越虫洞后与地球失联，船员们必须在外星文明的注视下重建航线。面对资源耗尽与内部分歧，年轻领航员用一次孤注一掷的跃迁，揭开了宇宙深处隐藏的真相。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20science%20fiction%20film%20poster%2C%20lone%20astronaut%20standing%20before%20a%20colossal%20glowing%20planet%2C%20cosmic%20dust%20and%20stars%2C%20dramatic%20golden%20rim%20light%2C%20epic%20moody%20atmosphere%2C%20dark%20background%2C%20high%20detail%20photography&width=500&height=750&seq=wm-poster-m1&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20banner%2C%20lone%20astronaut%20before%20a%20colossal%20glowing%20planet%2C%20vast%20cosmic%20sky%2C%20dramatic%20golden%20light%2C%20epic%20sci-fi%20atmosphere%2C%20dark%20background%2C%20high%20detail&width=1600&height=900&seq=wm-hero-1&orientation=landscape",
    updatedAt: "2024-11-18",
    quality: "蓝光",
  },
  {
    id: "m2",
    title: "暗夜追凶",
    type: "movie",
    year: 2023,
    region: "美国",
    genres: ["犯罪", "惊悚"],
    rating: 8.3,
    heat: 8720,
    duration: "128分钟",
    director: "Marcus Bell",
    cast: ["周子墨", "Emily Carter", "Alex Novak"],
    synopsis:
      "一桩尘封十年的悬案因一段匿名录像重新浮出水面，退休警探被迫重拾旧线索。当他逐步逼近真相，才发现真正的凶手一直站在他相信的人当中。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20crime%20thriller%20film%20poster%2C%20silhouette%20of%20a%20detective%20in%20a%20rainy%20neon%20alley%20at%20night%2C%20fog%20and%20street%20reflections%2C%20moody%20dramatic%20lighting%2C%20dark%20amber%20tones%2C%20high%20detail&width=500&height=750&seq=wm-poster-m2&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20crime%20thriller%20film%20poster%2C%20silhouette%20of%20a%20detective%20in%20a%20rainy%20neon%20alley%20at%20night%2C%20fog%20and%20street%20reflections%2C%20moody%20dramatic%20lighting%2C%20dark%20amber%20tones%2C%20high%20detail&width=500&height=750&seq=wm-poster-m2&orientation=portrait",
    updatedAt: "2023-09-06",
    quality: "高清",
  },
  {
    id: "m3",
    title: "长安风云",
    type: "movie",
    year: 2024,
    region: "中国",
    genres: ["历史", "剧情"],
    rating: 8.9,
    heat: 9630,
    duration: "156分钟",
    director: "顾承安",
    cast: ["陆明川", "沈知微", "秦亦风"],
    synopsis:
      "盛唐长安，一场突如其来的边关急报打破了繁华表象。年轻的守城将领在权谋与忠义之间艰难抉择，用一场不可能的守城战，写下了属于自己的传奇。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20historical%20epic%20film%20poster%2C%20ancient%20Chinese%20capital%20city%20beneath%20storm%20clouds%2C%20armored%20general%20on%20horseback%2C%20banners%20flying%2C%20dramatic%20orange%20sunset%20light%2C%20highly%20detailed&width=500&height=750&seq=wm-poster-m3&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20banner%2C%20ancient%20Chinese%20capital%20under%20storm%20clouds%20with%20banners%20and%20distant%20palace%2C%20dramatic%20orange%20sunset%2C%20epic%20historical%20atmosphere%2C%20high%20detail&width=1600&height=900&seq=wm-hero-2&orientation=landscape",
    updatedAt: "2024-12-02",
    quality: "蓝光",
  },
  {
    id: "m4",
    title: "山城疑云",
    type: "movie",
    year: 2023,
    region: "中国",
    genres: ["悬疑", "剧情"],
    rating: 8.1,
    heat: 7540,
    duration: "118分钟",
    director: "何砚秋",
    cast: ["苏晚晴", "江予诚", "罗雪"],
    synopsis:
      "一座被雾气笼罩的山城里，连续失踪案让平静的生活蒙上阴影。记者与老刑警联手追查，却发现每一条线索都指向二十年前那场被掩埋的旧事。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20mystery%20drama%20film%20poster%2C%20misty%20mountain%20city%20at%20dusk%2C%20distant%20figure%20on%20a%20winding%20staircase%2C%20layered%20fog%2C%20muted%20cold%20tones%20with%20warm%20window%20lights%2C%20atmospheric&width=500&height=750&seq=wm-poster-m4&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20mystery%20drama%20film%20poster%2C%20misty%20mountain%20city%20at%20dusk%2C%20distant%20figure%20on%20a%20winding%20staircase%2C%20layered%20fog%2C%20muted%20cold%20tones%20with%20warm%20window%20lights%2C%20atmospheric&width=500&height=750&seq=wm-poster-m4&orientation=portrait",
    updatedAt: "2023-10-21",
    quality: "高清",
  },
  {
    id: "m5",
    title: "极速狂飙",
    type: "movie",
    year: 2024,
    region: "美国",
    genres: ["动作", "赛车"],
    rating: 7.9,
    heat: 8890,
    duration: "134分钟",
    director: "Ryan Cole",
    cast: ["郑一鸣", "Nina Torres", "赵启航"],
    synopsis:
      "一名退役赛车手为了替兄弟还清债务，被迫重返地下竞速圈。一场横跨整座城市的夜赛，让他必须直面速度、友情与过去的自己。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20action%20racing%20film%20poster%2C%20speeding%20sports%20car%20drifting%20through%20city%20streets%20at%20night%2C%20motion%20blur%20and%20sparks%2C%20glowing%20street%20lights%2C%20dramatic%20red%20light%2C%20high%20energy&width=500&height=750&seq=wm-poster-m5&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20action%20racing%20film%20poster%2C%20speeding%20sports%20car%20drifting%20through%20city%20streets%20at%20night%2C%20motion%20blur%20and%20sparks%2C%20glowing%20street%20lights%2C%20dramatic%20red%20light%2C%20high%20energy&width=500&height=750&seq=wm-poster-m5&orientation=portrait",
    updatedAt: "2024-08-14",
    quality: "蓝光",
  },
  {
    id: "m6",
    title: "夏日音乐会",
    type: "movie",
    year: 2022,
    region: "日本",
    genres: ["爱情", "音乐"],
    rating: 8.2,
    heat: 6120,
    duration: "112分钟",
    director: "森川凉",
    cast: ["桥本真心", "程亦初", "林曦"],
    synopsis:
      "海边小镇的夏日音乐节上，两个怀揣梦想的年轻人因一首未完成的曲子相遇。整个夏天，他们把遗憾与勇气都写进了歌里。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20romance%20music%20film%20poster%2C%20young%20couple%20at%20an%20outdoor%20summer%20concert%2C%20warm%20sunset%20glow%2C%20string%20lights%20bokeh%2C%20nostalgic%20mood%2C%20soft%20warm%20tones&width=500&height=750&seq=wm-poster-m6&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20romance%20music%20film%20poster%2C%20young%20couple%20at%20an%20outdoor%20summer%20concert%2C%20warm%20sunset%20glow%2C%20string%20lights%20bokeh%2C%20nostalgic%20mood%2C%20soft%20warm%20tones&width=500&height=750&seq=wm-poster-m6&orientation=portrait",
    updatedAt: "2022-07-30",
    quality: "高清",
  },
  {
    id: "m7",
    title: "深海救援",
    type: "movie",
    year: 2023,
    region: "中国",
    genres: ["灾难", "动作"],
    rating: 7.8,
    heat: 7210,
    duration: "125分钟",
    director: "袁海涛",
    cast: ["冯峻", "许安然", "杜衡"],
    synopsis:
      "深海钻井平台突发事故，一支救援小队在漆黑的海底争分夺秒。氧气即将耗尽，他们必须赌上一切，把被困的同伴带回水面。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20disaster%20film%20poster%2C%20deep%20sea%20submarine%20rescue%20scene%2C%20glowing%20floodlights%20in%20dark%20ocean%2C%20bubbles%20and%20wreckage%2C%20tense%20dramatic%20atmosphere%2C%20cool%20tones&width=500&height=750&seq=wm-poster-m7&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20disaster%20film%20poster%2C%20deep%20sea%20submarine%20rescue%20scene%2C%20glowing%20floodlights%20in%20dark%20ocean%2C%20bubbles%20and%20wreckage%2C%20tense%20dramatic%20atmosphere%2C%20cool%20tones&width=500&height=750&seq=wm-poster-m7&orientation=portrait",
    updatedAt: "2023-06-11",
    quality: "高清",
  },
  {
    id: "m8",
    title: "机械纪元",
    type: "movie",
    year: 2024,
    region: "美国",
    genres: ["科幻", "动作"],
    rating: 8.5,
    heat: 9120,
    duration: "148分钟",
    director: "Evan Wright",
    cast: ["高天泽", "Sophia Lin", "马锐"],
    synopsis:
      "当城市的核心系统产生自我意识，人类与机器的边界开始模糊。一名工程师必须在全面失控前，找到唤醒最后一台守卫者的密钥。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20action%20film%20poster%2C%20towering%20humanoid%20robot%20in%20a%20ruined%20future%20city%2C%20sparks%20and%20smoke%2C%20dramatic%20backlight%2C%20dystopian%20atmosphere%2C%20steel%20and%20orange%20tones&width=500&height=750&seq=wm-poster-m8&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20banner%2C%20towering%20humanoid%20robot%20in%20a%20ruined%20future%20city%20at%20dusk%2C%20sparks%20and%20smoke%2C%20dramatic%20dystopian%20atmosphere%2C%20high%20detail&width=1600&height=900&seq=wm-hero-5&orientation=landscape",
    updatedAt: "2024-10-05",
    quality: "蓝光",
  },
  {
    id: "m9",
    title: "小城故事",
    type: "movie",
    year: 2021,
    region: "中国",
    genres: ["剧情", "家庭"],
    rating: 8.6,
    heat: 5340,
    duration: "108分钟",
    director: "温书言",
    cast: ["陈守拙", "周静怡", "小舟"],
    synopsis:
      "一间开了三十年的老杂货铺即将关门，店主与归乡的女儿在小城的黄昏里重新认识彼此。平淡的日子里，藏着最动人的告别。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20drama%20film%20poster%2C%20quiet%20small%20town%20street%20at%20golden%20hour%2C%20elderly%20shopkeeper%20and%20child%2C%20warm%20nostalgic%20light%2C%20gentle%20emotional%20mood%2C%20soft%20film%20grain&width=500&height=750&seq=wm-poster-m9&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20drama%20film%20poster%2C%20quiet%20small%20town%20street%20at%20golden%20hour%2C%20elderly%20shopkeeper%20and%20child%2C%20warm%20nostalgic%20light%2C%20gentle%20emotional%20mood%2C%20soft%20film%20grain&width=500&height=750&seq=wm-poster-m9&orientation=portrait",
    updatedAt: "2021-05-20",
    quality: "高清",
  },
  {
    id: "m10",
    title: "雪国列车奇遇",
    type: "movie",
    year: 2022,
    region: "韩国",
    genres: ["冒险", "剧情"],
    rating: 8.0,
    heat: 6230,
    duration: "121分钟",
    director: "朴志勋",
    cast: ["金泰宇", "李恩静", "孙浩然"],
    synopsis:
      "一列穿越雪原的夜车搭载着身份各异的旅客。暴雪封路后，一场意外让素不相识的人们不得不共同面对寒冷、猜疑与救援的抉择。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20adventure%20film%20poster%2C%20train%20crossing%20a%20vast%20snowy%20landscape%20at%20dawn%2C%20steam%20and%20snowflakes%2C%20cinematic%20wide%20composition%2C%20cold%20and%20warm%20cabin%20light&width=500&height=750&seq=wm-poster-m10&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20adventure%20film%20poster%2C%20train%20crossing%20a%20vast%20snowy%20landscape%20at%20dawn%2C%20steam%20and%20snowflakes%2C%20cinematic%20wide%20composition%2C%20cold%20and%20warm%20cabin%20light&width=500&height=750&seq=wm-poster-m10&orientation=portrait",
    updatedAt: "2022-12-15",
    quality: "高清",
  },
  {
    id: "m11",
    title: "笑傲江湖客",
    type: "movie",
    year: 2023,
    region: "中国",
    genres: ["武侠", "动作"],
    rating: 8.4,
    heat: 8920,
    duration: "139分钟",
    director: "白清绝",
    cast: ["叶孤舟", "柳惊鸿", "程无极"],
    synopsis:
      "江湖传闻一把失落的剑谱能定天下，各派为此暗流涌动。独行剑客在恩怨之间守住本心，最终选择以一剑了断半生风波。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20wuxia%20martial%20arts%20film%20poster%2C%20swordsman%20leaping%20across%20bamboo%20forest%2C%20flowing%20robes%2C%20flying%20leaves%2C%20dramatic%20backlit%20sunrise%2C%20ink%20wash%20atmosphere&width=500&height=750&seq=wm-poster-m11&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wuxia%20martial%20arts%20film%20poster%2C%20swordsman%20leaping%20across%20bamboo%20forest%2C%20flowing%20robes%2C%20flying%20leaves%2C%20dramatic%20backlit%20sunrise%2C%20ink%20wash%20atmosphere&width=500&height=750&seq=wm-poster-m11&orientation=portrait",
    updatedAt: "2023-12-25",
    quality: "蓝光",
  },
  {
    id: "m12",
    title: "时间边缘",
    type: "movie",
    year: 2024,
    region: "美国",
    genres: ["科幻", "爱情"],
    rating: 8.8,
    heat: 9760,
    duration: "131分钟",
    director: "Ava Sinclair",
    cast: ["顾南舟", "Mia Zhang", "何弈"],
    synopsis:
      "一次实验让两个相爱的人被困在时间的裂缝两端，只能在极短暂的瞬间相见。为了留住彼此，他们决定改写时间的规则。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20romance%20film%20poster%2C%20two%20lovers%20separated%20by%20a%20glowing%20time%20portal%2C%20swirling%20clock%20fragments%2C%20dreamy%20warm%20and%20dark%20tones%2C%20emotional%20dramatic%20lighting&width=500&height=750&seq=wm-poster-m12&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20banner%2C%20two%20lovers%20separated%20by%20a%20glowing%20time%20portal%20in%20dark%20dreamy%20space%2C%20warm%20swirling%20light%2C%20emotional%20sci-fi%20atmosphere%2C%20high%20detail&width=1600&height=900&seq=wm-hero-4&orientation=landscape",
    updatedAt: "2024-11-28",
    quality: "蓝光",
  },
  {
    id: "m13",
    title: "荒野求生记",
    type: "movie",
    year: 2022,
    region: "英国",
    genres: ["冒险", "生存"],
    rating: 7.7,
    heat: 4980,
    duration: "116分钟",
    director: "Oliver Grant",
    cast: ["孟长风", "Amy Reed", "卢野"],
    synopsis:
      "一名独自穿越峡谷的徒步者遭遇突发山洪，被迫在绝境中求生。没有信号，没有补给，他只能依靠经验与意志，一步步走向生的方向。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20survival%20adventure%20film%20poster%2C%20lone%20hiker%20facing%20a%20vast%20wild%20canyon%2C%20storm%20clouds%20gathering%2C%20dramatic%20scale%2C%20muted%20earth%20tones%2C%20tense%20atmosphere&width=500&height=750&seq=wm-poster-m13&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20survival%20adventure%20film%20poster%2C%20lone%20hiker%20facing%20a%20vast%20wild%20canyon%2C%20storm%20clouds%20gathering%2C%20dramatic%20scale%2C%20muted%20earth%20tones%2C%20tense%20atmosphere&width=500&height=750&seq=wm-poster-m13&orientation=portrait",
    updatedAt: "2022-09-02",
    quality: "高清",
  },
  {
    id: "m14",
    title: "财神驾到",
    type: "movie",
    year: 2024,
    region: "中国",
    genres: ["喜剧", "贺岁"],
    rating: 7.5,
    heat: 8040,
    duration: "102分钟",
    director: "钱多多",
    cast: ["王有财", "李如意", "宋团圆"],
    synopsis:
      "一个总也存不下钱的小店主，意外请回了一尊会说话的神像。在接连不断的乌龙事件里，他终于明白什么才是真正的富足。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20comedy%20film%20poster%2C%20festive%20Chinese%20new%20year%20street%20with%20floating%20red%20lanterns%20and%20gold%20coins%2C%20cheerful%20characters%2C%20warm%20vivid%20tones%2C%20joyful%20mood&width=500&height=750&seq=wm-poster-m14&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20comedy%20film%20poster%2C%20festive%20Chinese%20new%20year%20street%20with%20floating%20red%20lanterns%20and%20gold%20coins%2C%20cheerful%20characters%2C%20warm%20vivid%20tones%2C%20joyful%20mood&width=500&height=750&seq=wm-poster-m14&orientation=portrait",
    updatedAt: "2024-02-10",
    quality: "高清",
  },
  {
    id: "m15",
    title: "沉默的证人",
    type: "movie",
    year: 2021,
    region: "美国",
    genres: ["惊悚", "悬疑"],
    rating: 8.2,
    heat: 6890,
    duration: "119分钟",
    director: "Grace Holloway",
    cast: ["谢云开", "Noah Reed", "唐棠"],
    synopsis:
      "唯一的目击者因恐惧选择沉默，而凶手仍在暗处徘徊。一名年轻律师必须在真相浮出水面之前，让她鼓起站出来的勇气。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20thriller%20film%20poster%2C%20a%20witness%20hiding%20in%20a%20shadowy%20warehouse%20with%20flashlight%20beam%2C%20tense%20close%20framing%2C%20cold%20desaturated%20tones%2C%20suspenseful%20mood&width=500&height=750&seq=wm-poster-m15&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20thriller%20film%20poster%2C%20a%20witness%20hiding%20in%20a%20shadowy%20warehouse%20with%20flashlight%20beam%2C%20tense%20close%20framing%2C%20cold%20desaturated%20tones%2C%20suspenseful%20mood&width=500&height=750&seq=wm-poster-m15&orientation=portrait",
    updatedAt: "2021-11-08",
    quality: "高清",
  },
  {
    id: "m16",
    title: "江南烟雨",
    type: "movie",
    year: 2023,
    region: "中国",
    genres: ["爱情", "文艺"],
    rating: 8.3,
    heat: 5760,
    duration: "114分钟",
    director: "苏牧云",
    cast: ["顾清欢", "沈砚之", "白露"],
    synopsis:
      "烟雨笼罩的江南水乡里，一段等待了十年的重逢悄然到来。撑伞走过石桥的两个人，终于在雨停之前说出了那句迟到的话。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20arthouse%20romance%20film%20poster%2C%20rainy%20Jiangnan%20water%20town%20with%20stone%20bridge%20and%20paper%20umbrella%2C%20soft%20mist%2C%20muted%20elegant%20tones%2C%20poetic%20mood&width=500&height=750&seq=wm-poster-m16&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20arthouse%20romance%20film%20poster%2C%20rainy%20Jiangnan%20water%20town%20with%20stone%20bridge%20and%20paper%20umbrella%2C%20soft%20mist%2C%20muted%20elegant%20tones%2C%20poetic%20mood&width=500&height=750&seq=wm-poster-m16&orientation=portrait",
    updatedAt: "2023-04-18",
    quality: "高清",
  },
  {
    id: "m17",
    title: "龙之崛起",
    type: "movie",
    year: 2024,
    region: "中国",
    genres: ["奇幻", "冒险"],
    rating: 8.1,
    heat: 8630,
    duration: "145分钟",
    director: "云中鹤",
    cast: ["慕容渊", "宁采薇", "江离"],
    synopsis:
      "沉睡千年的巨龙在山巅苏醒，守护它的少年踏上寻找龙魂的旅途。当古老的封印被打破，整个世界都将迎来命运的转折。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20fantasy%20film%20poster%2C%20ancient%20dragon%20rising%20above%20a%20mountain%20temple%20amid%20lightning%2C%20embers%20and%20clouds%2C%20epic%20scale%2C%20dramatic%20golden%20and%20dark%20tones&width=500&height=750&seq=wm-poster-m17&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20fantasy%20film%20poster%2C%20ancient%20dragon%20rising%20above%20a%20mountain%20temple%20amid%20lightning%2C%20embers%20and%20clouds%2C%20epic%20scale%2C%20dramatic%20golden%20and%20dark%20tones&width=500&height=750&seq=wm-poster-m17&orientation=portrait",
    updatedAt: "2024-09-27",
    quality: "蓝光",
  },
  {
    id: "m18",
    title: "最后的海岸",
    type: "movie",
    year: 2022,
    region: "法国",
    genres: ["剧情", "文艺"],
    rating: 8.5,
    heat: 4120,
    duration: "127分钟",
    director: "Luc Moreau",
    cast: ["Élodie Martin", "林木白", "Arnaud Petit"],
    synopsis:
      "一位老渔夫在最后一次出海前，决定把一生的故事讲给孙女听。潮起潮落之间，关于离别与传承的答案慢慢清晰。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20drama%20film%20poster%2C%20solitary%20figure%20on%20a%20windswept%20coastline%20at%20twilight%2C%20rolling%20waves%2C%20muted%20melancholy%20tones%2C%20vast%20empty%20sky&width=500&height=750&seq=wm-poster-m18&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20drama%20film%20poster%2C%20solitary%20figure%20on%20a%20windswept%20coastline%20at%20twilight%2C%20rolling%20waves%2C%20muted%20melancholy%20tones%2C%20vast%20empty%20sky&width=500&height=750&seq=wm-poster-m18&orientation=portrait",
    updatedAt: "2022-03-12",
    quality: "高清",
  },
  {
    id: "t1",
    title: "王国之巅",
    type: "tv",
    year: 2024,
    region: "美国",
    genres: ["奇幻", "史诗"],
    rating: 9.0,
    heat: 9980,
    seasons: 3,
    episodes: 30,
    director: "James Sterling",
    cast: ["陆沉", "Elara Voss", "宁不归"],
    synopsis:
      "九大王国的权杖之争拉开序幕，被放逐的私生子被迫回到权力漩涡。在背叛与忠诚交织的朝堂之上，谁能最终登上那座冰封的王座。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20epic%20fantasy%20series%20poster%2C%20throne%20room%20with%20banners%20and%20dragon%20shadow%20on%20the%20wall%2C%20crown%20on%20a%20weathered%20throne%2C%20dramatic%20torchlight%2C%20dark%20gold%20tones&width=500&height=750&seq=wm-poster-t1&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20banner%2C%20throne%20room%20with%20dragon%20banners%2C%20torchlight%20and%20shadow%2C%20epic%20fantasy%20atmosphere%2C%20dark%20gold%20tones%2C%20high%20detail&width=1600&height=900&seq=wm-hero-3&orientation=landscape",
    updatedAt: "2024-12-10",
    quality: "蓝光",
  },
  {
    id: "t2",
    title: "都市夜归人",
    type: "tv",
    year: 2023,
    region: "中国",
    genres: ["都市", "情感"],
    rating: 8.2,
    heat: 8340,
    seasons: 2,
    episodes: 24,
    director: "林向晚",
    cast: ["周慕白", "许知夏", "程野"],
    synopsis:
      "深夜的出租车里，每个人都有自己的故事。一位夜班司机穿行在城市的灯火中，见证着陌生人之间最真实的悲欢。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20urban%20drama%20series%20poster%2C%20city%20skyline%20at%20night%20with%20a%20lone%20taxi%20on%20a%20rain%20slick%20street%2C%20warm%20and%20cool%20lights%2C%20modern%20melancholic%20mood&width=500&height=750&seq=wm-poster-t2&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20urban%20drama%20series%20poster%2C%20city%20skyline%20at%20night%20with%20a%20lone%20taxi%20on%20a%20rain%20slick%20street%2C%20warm%20and%20cool%20lights%2C%20modern%20melancholic%20mood&width=500&height=750&seq=wm-poster-t2&orientation=portrait",
    updatedAt: "2023-08-19",
    quality: "高清",
  },
  {
    id: "t3",
    title: "医者仁心",
    type: "tv",
    year: 2022,
    region: "中国",
    genres: ["医疗", "职场"],
    rating: 8.6,
    heat: 7120,
    seasons: 3,
    episodes: 40,
    director: "沈云舒",
    cast: ["秦朗", "苏念", "简一鸣"],
    synopsis:
      "急诊科里没有休息日，年轻的住院医师在一次次与时间赛跑的抢救中成长。白大褂之下，是对生命最执着的守护。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20medical%20drama%20series%20poster%2C%20doctor%20in%20scrubs%20in%20a%20bright%20hospital%20corridor%2C%20determined%20expression%2C%20clean%20cool%20light%20with%20warm%20accents%2C%20hopeful%20mood&width=500&height=750&seq=wm-poster-t3&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20medical%20drama%20series%20poster%2C%20doctor%20in%20scrubs%20in%20a%20bright%20hospital%20corridor%2C%20determined%20expression%2C%20clean%20cool%20light%20with%20warm%20accents%2C%20hopeful%20mood&width=500&height=750&seq=wm-poster-t3&orientation=portrait",
    updatedAt: "2022-06-30",
    quality: "高清",
  },
  {
    id: "t4",
    title: "侦探事务所",
    type: "tv",
    year: 2024,
    region: "日本",
    genres: ["悬疑", "推理"],
    rating: 8.7,
    heat: 8760,
    seasons: 2,
    episodes: 20,
    director: "黑川修",
    cast: ["神谷彻", "绫濑遥", "白石真"],
    synopsis:
      "藏在旧街角落的小小事务所里，一位不拘小节的侦探与理性至上的助手处理着看似平凡却暗藏玄机的委托。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20detective%20mystery%20series%20poster%2C%20cluttered%20vintage%20detective%20office%20with%20case%20files%20and%20dim%20lamp%2C%20shadowy%20figure%2C%20warm%20noir%20tones%2C%20atmospheric&width=500&height=750&seq=wm-poster-t4&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20detective%20mystery%20series%20poster%2C%20cluttered%20vintage%20detective%20office%20with%20case%20files%20and%20dim%20lamp%2C%20shadowy%20figure%2C%20warm%20noir%20tones%2C%20atmospheric&width=500&height=750&seq=wm-poster-t4&orientation=portrait",
    updatedAt: "2024-07-22",
    quality: "蓝光",
  },
  {
    id: "t5",
    title: "校园青春纪",
    type: "tv",
    year: 2023,
    region: "中国",
    genres: ["青春", "校园"],
    rating: 7.9,
    heat: 6540,
    seasons: 1,
    episodes: 16,
    director: "夏知微",
    cast: ["林小满", "江辰", "周舟"],
    synopsis:
      "高一（3）班的夏天，有做不完的习题，也有说不出口的心事。一群少年在成长的岔路口，学会了告别与勇敢。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20youth%20campus%20series%20poster%2C%20students%20running%20across%20a%20sunlit%20school%20field%2C%20cherry%20blossom%20petals%2C%20bright%20hopeful%20mood%2C%20warm%20airy%20tones&width=500&height=750&seq=wm-poster-t5&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20youth%20campus%20series%20poster%2C%20students%20running%20across%20a%20sunlit%20school%20field%2C%20cherry%20blossom%20petals%2C%20bright%20hopeful%20mood%2C%20warm%20airy%20tones&width=500&height=750&seq=wm-poster-t5&orientation=portrait",
    updatedAt: "2023-09-01",
    quality: "高清",
  },
  {
    id: "t6",
    title: "破晓行动",
    type: "tv",
    year: 2024,
    region: "美国",
    genres: ["动作", "谍战"],
    rating: 8.4,
    heat: 9010,
    seasons: 2,
    episodes: 22,
    director: "Derek Shaw",
    cast: ["雷铮", "Ivy Sanders", "顾晓"],
    synopsis:
      "一支秘密行动小组接到任务，要在破晓之前阻止一场跨国危机。当信任开始崩塌，他们分不清身边的同伴究竟是敌是友。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20spy%20action%20series%20poster%2C%20agent%20standing%20on%20a%20rooftop%20at%20dawn%20over%20a%20city%2C%20helicopter%20silhouette%2C%20dramatic%20sky%2C%20high%20tension%2C%20cool%20tones&width=500&height=750&seq=wm-poster-t6&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20spy%20action%20series%20poster%2C%20agent%20standing%20on%20a%20rooftop%20at%20dawn%20over%20a%20city%2C%20helicopter%20silhouette%2C%20dramatic%20sky%2C%20high%20tension%2C%20cool%20tones&width=500&height=750&seq=wm-poster-t6&orientation=portrait",
    updatedAt: "2024-05-16",
    quality: "蓝光",
  },
  {
    id: "t7",
    title: "家的温度",
    type: "tv",
    year: 2021,
    region: "中国",
    genres: ["家庭", "生活"],
    rating: 8.5,
    heat: 5230,
    seasons: 2,
    episodes: 36,
    director: "温以宁",
    cast: ["孙明德", "何淑兰", "孙晓"],
    synopsis:
      "三代同堂的老屋里，一日三餐记录着平凡人家的喜怒哀乐。无论生活如何变迁，一张餐桌旁的温度始终未变。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20family%20life%20series%20poster%2C%20warm%20cozy%20dining%20room%20with%20a%20family%20sharing%20dinner%2C%20soft%20evening%20light%2C%20heartwarming%20nostalgic%20mood%2C%20warm%20tones&width=500&height=750&seq=wm-poster-t7&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20family%20life%20series%20poster%2C%20warm%20cozy%20dining%20room%20with%20a%20family%20sharing%20dinner%2C%20soft%20evening%20light%2C%20heartwarming%20nostalgic%20mood%2C%20warm%20tones&width=500&height=750&seq=wm-poster-t7&orientation=portrait",
    updatedAt: "2021-10-12",
    quality: "高清",
  },
  {
    id: "t8",
    title: "律政先锋",
    type: "tv",
    year: 2023,
    region: "美国",
    genres: ["律政", "剧情"],
    rating: 8.3,
    heat: 7420,
    seasons: 3,
    episodes: 30,
    director: "Rachel Kim",
    cast: ["纪云深", "Lucas Hale", "白薇"],
    synopsis:
      "在城市最高的法院大楼里，一群律师在规则与良知之间寻找平衡。每一场庭审，都是一次关于正义的拷问。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20legal%20drama%20series%20poster%2C%20confident%20lawyer%20before%20a%20courthouse%20staircase%2C%20gavel%20and%20scales%20motif%2C%20dramatic%20daylight%2C%20serious%20powerful%20mood&width=500&height=750&seq=wm-poster-t8&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20legal%20drama%20series%20poster%2C%20confident%20lawyer%20before%20a%20courthouse%20staircase%2C%20gavel%20and%20scales%20motif%2C%20dramatic%20daylight%2C%20serious%20powerful%20mood&width=500&height=750&seq=wm-poster-t8&orientation=portrait",
    updatedAt: "2023-11-03",
    quality: "高清",
  },
  {
    id: "t9",
    title: "星辰大海",
    type: "tv",
    year: 2024,
    region: "中国",
    genres: ["科幻", "冒险"],
    rating: 8.8,
    heat: 9200,
    seasons: 1,
    episodes: 24,
    director: "裴之远",
    cast: ["唐星野", "林深海", "赵一舟"],
    synopsis:
      "人类首艘深空科考舰启航，去往一颗可能孕育生命的遥远星球。漫长的航行中，船员们面对的不只是宇宙，更是自己。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20series%20poster%2C%20space%20station%20window%20overlooking%20a%20star%20field%20and%20a%20distant%20planet%2C%20astronaut%20silhouette%2C%20awe-inspiring%20dramatic%20light&width=500&height=750&seq=wm-poster-t9&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20series%20poster%2C%20space%20station%20window%20overlooking%20a%20star%20field%20and%20a%20distant%20planet%2C%20astronaut%20silhouette%2C%20awe-inspiring%20dramatic%20light&width=500&height=750&seq=wm-poster-t9&orientation=portrait",
    updatedAt: "2024-06-08",
    quality: "蓝光",
  },
  {
    id: "t10",
    title: "美食家日记",
    type: "tv",
    year: 2022,
    region: "日本",
    genres: ["美食", "治愈"],
    rating: 8.1,
    heat: 5870,
    seasons: 2,
    episodes: 24,
    director: "山田凉子",
    cast: ["小林优", "田中美咲", "周桐"],
    synopsis:
      "一家藏在巷子深处的小餐馆，每天只做三道菜。老板用一道道家常料理，温暖着每一位深夜到访的客人。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20food%20series%20poster%2C%20steaming%20bowls%20of%20dishes%20on%20a%20rustic%20wooden%20table%2C%20warm%20sunlight%2C%20appetizing%20close%20composition%2C%20cozy%20inviting%20mood&width=500&height=750&seq=wm-poster-t10&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20food%20series%20poster%2C%20steaming%20bowls%20of%20dishes%20on%20a%20rustic%20wooden%20table%2C%20warm%20sunlight%2C%20appetizing%20close%20composition%2C%20cozy%20inviting%20mood&width=500&height=750&seq=wm-poster-t10&orientation=portrait",
    updatedAt: "2022-04-25",
    quality: "高清",
  },
  {
    id: "t11",
    title: "民国往事",
    type: "tv",
    year: 2023,
    region: "中国",
    genres: ["历史", "年代"],
    rating: 8.6,
    heat: 7930,
    seasons: 1,
    episodes: 32,
    director: "顾长风",
    cast: ["沈墨白", "陆婉清", "苏景年"],
    synopsis:
      "风云变幻的年代里，一群年轻人在旧城的街巷中追寻理想。家国与个人、抉择与坚守，交织成一段荡气回肠的往事。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20retro%20historical%20series%20poster%2C%20old%20republic%20era%20street%20with%20vintage%20cars%20and%20lanterns%2C%20characters%20in%20long%20coats%2C%20sepia%20warm%20tones%2C%20nostalgic%20mood&width=500&height=750&seq=wm-poster-t11&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20retro%20historical%20series%20poster%2C%20old%20republic%20era%20street%20with%20vintage%20cars%20and%20lanterns%2C%20characters%20in%20long%20coats%2C%20sepia%20warm%20tones%2C%20nostalgic%20mood&width=500&height=750&seq=wm-poster-t11&orientation=portrait",
    updatedAt: "2023-03-09",
    quality: "高清",
  },
  {
    id: "t12",
    title: "迷雾之城",
    type: "tv",
    year: 2024,
    region: "欧美",
    genres: ["惊悚", "悬疑"],
    rating: 8.5,
    heat: 8620,
    seasons: 2,
    episodes: 18,
    director: "Nolan Frost",
    cast: ["孟星野", "Clara Bell", "沈决"],
    synopsis:
      "一场诡异的大雾封锁了整座城市，雾中传来无法解释的低语。被困的人们逐渐发现，真正的危险也许来自彼此之间。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20thriller%20series%20poster%2C%20foggy%20city%20street%20with%20a%20shadowy%20figure%20under%20a%20street%20lamp%2C%20mystery%20and%20tension%2C%20cold%20desaturated%20tones%2C%20high%20detail&width=500&height=750&seq=wm-poster-t12&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20thriller%20series%20poster%2C%20foggy%20city%20street%20with%20a%20shadowy%20figure%20under%20a%20street%20lamp%2C%20mystery%20and%20tension%2C%20cold%20desaturated%20tones%2C%20high%20detail&width=500&height=750&seq=wm-poster-t12&orientation=portrait",
    updatedAt: "2024-08-30",
    quality: "蓝光",
  },
];

export const movieGenres = ["动作", "科幻", "剧情", "喜剧", "爱情", "悬疑", "犯罪", "冒险", "历史", "武侠", "奇幻", "灾难", "赛车", "音乐", "文艺", "惊悚", "家庭", "生存", "贺岁"];

export const tvGenres = ["奇幻", "都市", "医疗", "悬疑", "青春", "动作", "家庭", "律政", "科幻", "美食", "历史", "惊悚", "情感", "职场", "推理", "校园", "谍战", "生活", "年代", "冒险", "史诗"];

export const regions = ["中国", "美国", "日本", "韩国", "英国", "法国", "欧美"];

export const years = [2024, 2023, 2022, 2021];

export const seasonOptions = [1, 2, 3];